import request from '@/api/request'
import { weblinkRequest, externalRequest } from '../request'
// import data from './mock-data/index'

export default {
  getNewOpportunity () {
    const url = `/opportunity/new`
    return request({
      method: 'GET',
      url,
      headers: { 'Cache-Control': 'no-cache' }
    })
  },

  searchOpportunity (payload) {
    const url = `/opportunity/search`
    const data = payload
    return request({ method: 'POST', url, data })
  },

  saveNewOpportunity (payload) {
    const url = `/opportunity/save`
    const data = payload
    return request({ method: 'POST', url, data })
  },
  async publishOpportunity (payload) {
    const url = `/opportunity/publish`
    const data = payload
    return request({ method: 'POST', url, data })
  },
  async saveNewOpportunityByExtenal (payload) {
    const url = `/itinerary/days/${payload.id}/process`
    const data = payload.itineraries
    return externalRequest({ method: 'POST', url, data })
  },
  getOpportunity (uuid) {
    const url = `/opportunity/get/${uuid}`
    return request({
      method: 'GET',
      url,
      headers: { 'Cache-Control': 'no-cache' }
    })
    // return new Promise((resolve, reject) => {
    //  resolve(data)
    // })
  },
  getPublishedOpportunity (uuid) {
    const url = `/itp/client/get/${uuid}`
    return weblinkRequest({
      method: 'GET',
      url,
      headers: { 'Cache-Control': 'no-cache' }
    })
  },
  listOpportunities (payload) {
    const url = `/opportunity/list`
    const data = payload
    return request({ method: 'POST', url, data })
  },

  listOpportunitiesSaved (type) {
    const url = `/opportunity/list/${type}`
    return request({
      method: 'GET',
      url,
      headers: { 'Cache-Control': 'no-cache' }
    })
  },

  downloadQuotePDF (payload) {
    const url = `/opportunity/download/pdf`
    const data = payload
    return request({ method: 'POST', url, data, responseType: 'arraybuffer' })
  },

  downloadFlyerPDF (payload) {
    const url = `/opportunity/flyer/download/pdf`
    const data = payload
    return request({ method: 'POST', url, data, responseType: 'arraybuffer' })
  },

  duplicateOpportunity (payload) {
    const url = `/opportunity/duplicate`
    const data = payload
    return request({ method: 'POST', url, data })
  },

  analyze (payload) {
    const url = `/opportunity/analyze`
    const data = payload
    return request({ method: 'POST', url, data })
  },

  deleteOpportunity (payload) {
    const url = `/opportunity/delete`
    const data = payload
    return request({ method: 'DELETE', url, data })
  },

  suggestImages (payload) {
    const url = `/opportunity/images/suggest/${payload}`
    return request({ method: 'POST', url })
  },

  searchSignature (payload) {
    const url = `/opportunity/signature/all/${payload}`
    return request({
      method: 'GET',
      url,
      headers: { 'Cache-Control': 'no-cache' }
    })
  },

  processSignature (payload) {
    const data = [payload]
    const url = `/opportunity/signature/save/${payload.parent}`
    return request({ method: 'POST', url, data })
  }
}
